import { memo } from "react";
import { formattedDateTimeWithoutSec } from "../../../lib/functions";

interface DetailedDescriptionOfItemsProps {
    permitItems: {
        s_ItemType: string;
        n_Quantity: number;
        s_SupplyingOrExportingEntity: string;
    }[]
}

const DetailedDescriptionOfItems = ({ permitItems }: DetailedDescriptionOfItemsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-t border-black py-0.5">
                <span className="text-[10px] text-white font-bold">
                    Section 4: Detailed Description of Items
                </span>
            </div>

            <table className="w-full text-xs">
                <thead>
                    <tr className="bg-gray-300">
                        <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
                            Item Type
                        </th>
                        <th className="border-y-[0.2px] border-l-[0.2px] border-r-[0.2px] border-black p-1 text-[10px] h-4">
                            Quantity
                        </th>
                        <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
                            Supplying or Exporting Entity for the Permit Holder
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {permitItems?.map((row, idx) => (
                        <tr key={idx}>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.s_ItemType}
                            </td>
                            <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.n_Quantity}
                            </td>
                            <td className="border-b-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                                {row.s_SupplyingOrExportingEntity}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default memo(DetailedDescriptionOfItems);
